import { ProductsTypeEnum } from '@app/forms/subscription/definition/interface';
import { Parameters, PledgeRead } from '../definition/interface/Pledge';

import { CommandEnum, CompanyFieldType } from '../definition/interface/enum';

export const oneValueRequiredOwners = (
  pledge: PledgeRead,
  keys: string[],
): boolean => {
  return keys?.some(p => pledge?.owners.some(o => o?.riskProfil?.[p]));
};

export const getAdditionalQuestions = (parameters: Parameters, type: any) => {
  return parameters?.additionalQuestions?.find(q => q?.id === type);
};

export const isFieldRequired = (
  parameters: Parameters,
  type: CompanyFieldType,
): boolean => {
  return (
    getAdditionalQuestions(parameters, type)?.required === 'MANDATORY' || false
  );
};
const productTypeMappings = {
  [ProductsTypeEnum.PRIVATE_EQUITY]: 'PME',
};
const reverseProductTypeMappings = Object.entries(productTypeMappings).reduce(
  (acc, [key, value]) => {
    acc[value] = key;
    return acc;
  },
  {},
);
export function mapProductType(
  type: keyof typeof ProductsTypeEnum,
): ProductsTypeEnum {
  return productTypeMappings[type] || type;
}
export function reverseMapProductType(
  type: keyof typeof ProductsTypeEnum,
): keyof typeof ProductsTypeEnum {
  return reverseProductTypeMappings[type] || type;
}
export function getCommands(): CommandEnum[] {
  return [CommandEnum.RECALCULATE_RISK_PROFIL];
}
